// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"styles_buttonsContainer__XzDFG","qr-code":"styles_qr-code__DU67J"};